import React, { useEffect, useState } from "react";

const ManagementMain = () => {
  const [managementList, setManagementList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchManagementData = async () => {
      try {
        const response = await fetch(`${baseUrl}/api/management/`);
        console.log("API URL:", `${baseUrl}/api/management/`);
        if (!response.ok) {
          throw new Error("Failed to fetch management data");
        }
        const data = await response.json();
        console.log(data)
        setManagementList(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchManagementData();
  }, [baseUrl]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div className="p-2 md:mx-32 sm:p-4 md:p-10 management-container">
      <h1 className="mt-4 mb-4 text-2xl text-center text-justify text-gray-800 sm:mb-8 sm:text-3xl md:text-4xl md:text-center md:mb-16">
        Meet Our Leaders
      </h1>
      <div className="grid gap-4 mx-0 sm:gap-6 md:gap-10 md:mx-32 management-cards">
        {managementList.map((person, index) => (
          <div
            key={person.id}
            className="p-2 bg-white shadow-sm card rounded-xl hover:shadow-lg sm:p-4"
          >
            <div
              className={`flex flex-col md:flex-row ${
                index % 2 === 0 ? "lg:flex-row" : "lg:flex-row-reverse"
              } md:items-start md:gap-6`}
            >
              <img
                src={person.image}
                alt={person.name}
                className="w-full mx-auto my-2 rounded-xl md:w-[320px] lg:w-[600px] md:h-[400px] object-cover"
              />
              <div
                className={`p-2 sm:p-4 md:p-6 ${
                  index % 2 === 0 ? "md:pl-6" : "md:ml-6"
                } text-left flex flex-col justify-center`}
              >
                <h2 className="text-xl sm:text-2xl md:text-4xl font-bold text-[#A14D1F] text-center md:text-left">
                  {person.name}
                </h2>
                <h4 className="mb-1 text-base font-semibold text-center text-gray-600 sm:mb-2 sm:text-lg md:mb-4 md:text-xl md:text-left">
                  {person.designation}
                </h4>
                <p
                  className="text-xs text-justify text-gray-700 sm:text-sm md:text-base"
                  dangerouslySetInnerHTML={{ __html: person.message }}
                ></p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ManagementMain;
